import React from 'react'
import './src/styles/global.css'
import { LanguageProvider } from './src/context/LanguageContext'
import Layout from './src/components/common/Layout'

import { loadGA4, loadFBPixel, trackPageView } from './src/utils/tracking'

// TODO: Put your IDs in env vars
// const GA_ID = process.env.GATSBY_GA_ID
// const FB_PIXEL_ID = process.env.GATSBY_FB_PIXEL_ID
const GA_ID = 'G-SCN26RTCNN'
const FB_PIXEL_ID = '1226337109257372'

export const wrapRootElement = ({ element }) => <LanguageProvider>{element}</LanguageProvider>

export const wrapPageElement = ({ element }) => <Layout>{element}</Layout>

/**
 * If the user had already given consent on a previous visit,
 * load the trackers immediately on app start.
 */
export const onClientEntry = () => {
  if (typeof window === 'undefined') return
  const consent = localStorage.getItem('ga-consent') === 'true'
  if (!consent) return
  loadGA4(GA_ID)
  loadFBPixel(FB_PIXEL_ID)
}

/**
 * Fire a PageView on every SPA navigation.
 * Safe to call even if trackers haven’t been injected yet.
 */
export const onRouteUpdate = ({ location }) => {
  if (typeof window === 'undefined') return
  const consent = localStorage.getItem('ga-consent') === 'true'
  if (!consent) return
  // will call fbq('track','PageView') and GA4 page_view if available
  trackPageView(location?.pathname + (location?.search || ''))
}
